import { render, staticRenderFns } from "./VRInput.vue?vue&type=template&id=06694001"
import script from "./VRInput.vue?vue&type=script&lang=js"
export * from "./VRInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports